import { render, staticRenderFns } from "./Project19.vue?vue&type=template&id=4ac22d22&scoped=true&"
import script from "./Project19.vue?vue&type=script&lang=js&"
export * from "./Project19.vue?vue&type=script&lang=js&"
import style0 from "./Project19.vue?vue&type=style&index=0&id=4ac22d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac22d22",
  null
  
)

export default component.exports